import { FormApi } from 'final-form';
import { unflatten } from 'flat';
import { Dispatch } from 'redux-api-middleware';

import {
  DispatchAction,
  GenericFormResponse,
  SuccessCallback,
  ValidationErrorCallback,
  ValidationErrors,
} from './submitForm.types';

export const submitForm = <T>(dispatch: Dispatch, action: DispatchAction<T>) => async (
  formValues: object,
  formApi?: FormApi,
  onSuccess?: SuccessCallback<T>,
  onValidationError?: ValidationErrorCallback,
): Promise<ValidationErrors | T | void> => {
  const results = await dispatch<Promise<GenericFormResponse>>(action(formValues, formApi));

  if (
    results.payload &&
    results.payload.status === 400 &&
    results.payload.response &&
    results.payload.response.errors
  ) {
    const errors = results.payload.response.errors
      ? results.payload.response.errors.reduce((prev, curr) => ({ ...prev, [curr.field]: curr.defaultMessage }), {})
      : [];

    if (onValidationError) {
      onValidationError(unflatten(errors));
    }

    return Promise.resolve(unflatten(errors));
  }

  if (results.error) {
    return Promise.reject(results);
  }

  if (onSuccess) {
    onSuccess((results as unknown) as T);
  }

  return Promise.resolve();
};
